import React from "react";
import { Cell, Row } from "react-table";
import TableCell from "./TableCell";

interface Props {
	row: Row<{
		[key: string]: string;
	}>;
	backgroundColor: string;
	rowsLength: number;
}

const RowContent = ({ row, backgroundColor, rowsLength }: Props) => {
	const checkboxCell = row.cells.shift() as Cell<
		{ [key: string]: string },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		any
	>;

	return (
		<>
			<TableCell
				cell={checkboxCell}
				className="legacyArrayView-checkbox"
				isLastCell={false}
				rowIndex={row.index}
				rowsLength={rowsLength}
				backgroundColor={backgroundColor}
			/>
			{/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
			{row.cells.map((cell: Cell<{ [key: string]: string }, any>) => (
				<TableCell
					cell={cell}
					backgroundColor={backgroundColor}
					isLastCell={
						row.cells.indexOf(cell) === row.cells.length - 1
					}
					rowsLength={rowsLength}
					rowIndex={row.index}
					key={`${cell.row.id} ${cell.column.id}`}
				/>
			))}
		</>
	);
};

export default React.memo(RowContent, (prevProps, nextProps) => {
	return (
		prevProps.row.id === nextProps.row.id &&
		prevProps.backgroundColor === nextProps.backgroundColor &&
		prevProps.rowsLength === nextProps.rowsLength
	);
});
